import { render, staticRenderFns } from "./reward-result.vue?vue&type=template&id=1d4e7f13&scoped=true&"
import script from "./reward-result.vue?vue&type=script&setup=true&lang=ts&"
export * from "./reward-result.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./reward-result.vue?vue&type=style&index=0&id=1d4e7f13&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e7f13",
  null
  
)

export default component.exports